<dx-select-box
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  width="100%"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-switch *ngIf="templateItem.fieldType != 'udx' && hasSystem"
           style="margin-left: 25px; align-self: center;"
           [(value)]="pimField.useSequence"
           (onValueChanged)="update()">
</dx-switch>

<dx-number-box *ngIf="hasSystem"
               class="flex-grow-1 np-highlight"
               [min]="1"
               label="{{ (pimField.useSequence ? 'Reihenfolgennummer' : 'Sortiernummer') | translate }}"
               [(value)]="pimField.systemKey"
               (onValueChanged)="onOrderChanged($event)"></dx-number-box>
